const Table = ({headers, rows, getColor}) => {
  return <table className="min-w-full divide-y divide-gray-200">
    <thead className="bg-gray-50">
    <tr>
      {headers.map(h => <th 
        key={h}
        scope="col"
        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      > {h} </th>)}
    </tr>
    </thead>
    <tbody className="bg-white divide-y divide-gray-200">
      {rows.map((r, ri) => {
        return <tr key={ri} onClick={r.onClick} onMouseEnter={r.onMouseEnter} onMouseLeave={r.onMouseLeave} >
          {headers.map(h => <td 
            key={h}
            className="px-6 py-1 whitespace-nowrap text-sm"
            style={getColor && getColor(r, h)}
          > {r[h]} </td>)}
        </tr>
      })}
    </tbody>
</table>
}
export default Table;


export const FixedTable = ({headers, rows, getColor}) => {
  return <table className="w-full table-fixed divide-y divide-gray-200">
    <thead className="bg-gray-50">
    <tr>
      {headers.map(h => <th 
        key={h}
        scope="col"
        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      > {h} </th>)}
    </tr>
    </thead>
    <tbody className="bg-white divide-y divide-gray-200">
      {rows.map((r, ri) => {
        return <tr key={ri} onClick={r.onClick} onMouseEnter={r.onMouseEnter} onMouseLeave={r.onMouseLeave} >
          {headers.map(h => <td 
            key={h}
            className="px-3 py-1 truncate hover:whitespace-normal text-sm"
            style={getColor && getColor(r, h)}
          > {r[h]} </td>)}
        </tr>
      })}
    </tbody>
</table>
}
